(function () {
  'use strict';

  // ---- Sticky header scroll state ----
  const header = document.querySelector('[data-sticky-header]');
  if (header) {
    const onScroll = () => {
      if (window.scrollY > 20) header.classList.add('scrolled');
      else header.classList.remove('scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---- FAQ accordion (one open at a time) ----
  document.querySelectorAll('[data-faq]').forEach((faq) => {
    const items = faq.querySelectorAll('[data-faq-item]');
    // On mobile (<= 760px) start with all items collapsed (no first-open)
    const isMobile = window.matchMedia('(max-width: 760px)').matches;
    if (isMobile) {
      items.forEach((item) => {
        item.classList.remove('open');
        const btn = item.querySelector('[data-faq-toggle]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }
    items.forEach((item) => {
      const btn = item.querySelector('[data-faq-toggle]');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const isOpen = item.classList.contains('open');
        items.forEach((other) => {
          other.classList.remove('open');
          const otherBtn = other.querySelector('[data-faq-toggle]');
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });

  // ---- FAQ icon (+ / −) — controlled via CSS class ----
  // We render the glyph in JS so screen readers don't read "+ / −" twice.
  document.querySelectorAll('.faq-icon').forEach((icon) => {
    const sync = () => {
      const item = icon.closest('[data-faq-item]');
      icon.textContent = item && item.classList.contains('open') ? '−' : '+';
    };
    sync();
    const item = icon.closest('[data-faq-item]');
    if (item) {
      const obs = new MutationObserver(sync);
      obs.observe(item, { attributes: true, attributeFilter: ['class'] });
    }
  });

  // ---- Product gallery: thumbnail click swaps main image ----
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const mainImg = section.querySelector('[data-gallery-main-img]');
    const thumbs = section.querySelectorAll('[data-gallery-thumb]');
    if (!mainImg || thumbs.length === 0) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.getAttribute('data-thumb-src');
        const srcset = thumb.getAttribute('data-thumb-srcset');
        if (src) mainImg.setAttribute('src', src);
        if (srcset) mainImg.setAttribute('srcset', srcset);
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });

  // ---- Product variant picker (option pills) ----
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const variantsScript = section.querySelector('[data-product-variants]');
    if (!variantsScript) return;

    let variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || variants.length === 0) return;

    const optionsRoot = section.querySelector('[data-product-options]');
    if (!optionsRoot) return;

    const optionGroups = optionsRoot.querySelectorAll('.product-option');

    const getCurrentSelections = () => {
      return Array.from(optionGroups).map((group) => {
        const selected = group.querySelector('.product-option-pill.is-selected');
        return selected ? selected.getAttribute('data-option-value') : null;
      });
    };

    const findVariant = (selections) => {
      return variants.find((v) => {
        if (!v.options) return false;
        return selections.every((sel, i) => sel === v.options[i]);
      });
    };

    const updateLabels = () => {
      optionGroups.forEach((group, i) => {
        const valueEl = group.querySelector('.product-option-value');
        const selected = group.querySelector('.product-option-pill.is-selected');
        if (valueEl && selected) {
          valueEl.textContent = selected.getAttribute('data-option-value');
        }
      });
    };

    const updatePriceAndUrl = (variant) => {
      if (!variant) return;
      const priceEl = section.querySelector('[data-product-price]');
      if (priceEl) {
        priceEl.innerHTML = '<strong>' + variant.price + '</strong><span class="product-price-meta"> · Envío gratis a España</span>';
      }
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      // If the variant has a featured media, switch the main gallery image to it.
      if (variant.featured_media_index !== null && variant.featured_media_index !== undefined) {
        const thumbs = section.querySelectorAll('[data-gallery-thumb]');
        const target = thumbs[variant.featured_media_index];
        if (target) target.click();
      }
    };

    optionsRoot.querySelectorAll('[data-option-pill]').forEach((pill) => {
      pill.addEventListener('click', () => {
        const groupIndex = parseInt(pill.getAttribute('data-option-index'), 10);
        const group = optionGroups[groupIndex];
        if (!group) return;
        group.querySelectorAll('.product-option-pill').forEach((p) => p.classList.remove('is-selected'));
        pill.classList.add('is-selected');

        updateLabels();
        const variant = findVariant(getCurrentSelections());
        updatePriceAndUrl(variant);
      });
    });
  });

  // ---- How-it-works rotators ----
  document.querySelectorAll('[data-rotator]').forEach((wrap) => {
    const interval = parseInt(wrap.getAttribute('data-interval') || '2600', 10);
    const offset = parseInt(wrap.getAttribute('data-offset') || '0', 10);
    const all = wrap.querySelectorAll('.how-sample-item, .how-sample-image');
    if (all.length < 2) return;
    let i = 0;
    const advance = () => {
      i = (i + 1) % all.length;
      all.forEach((el, idx) => {
        el.setAttribute('data-active', idx === i ? 'true' : 'false');
      });
    };
    setTimeout(() => setInterval(advance, interval), offset);
  });
})();
